import { Box } from '@nerdwallet/currency';
import Image from '~/app/components/image/image';
import styles from './mp4-video-player-cover.module.scss';
import PlayButtonDefaultIcon from '../../assets/play-button-default-image';

const defaultPlayerPlaceholderImageUrl =
  'https://www.nerdwallet.com/cdn/img/lpc/no-video-image.jpg';

export const VideoPlayerCover = () => (
  <Box className={styles.videoPlaceholder}>
    <PlayButtonDefaultIcon />
    <Image
      objectFit="cover"
      src={defaultPlayerPlaceholderImageUrl}
      alt="player-cover-image"
      backgroundColor="transparent"
      naturalWidth={564}
      naturalHeight={316}
      className="gray-out"
      lazy
    />
  </Box>
);
